class ProductCarouselManager {
  constructor() {
    this._splideAssetsRequested = false;
    this._boot = this._boot.bind(this);

    this._init(document);
    this._bindGlobalEvents();
  }

  _init(scope) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this._boot(scope));
    } else {
      this._boot(scope);
    }
  }

  _bindGlobalEvents() {
    if (typeof MutationObserver === 'undefined') return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!node || node.nodeType !== 1) return;

          if (node.matches?.('[data-product-carousel]')) {
            this._boot(node.parentNode || document);
            return;
          }
          if (node.querySelector?.('[data-product-carousel]')) {
            this._boot(node);
          }
        });
      });
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', () => this._boot(document));
  }

  _boot(scope) {
    if (!document.querySelector('link[href*="splide.min.css"]')) {
      const cssLink = document.createElement('link');
      cssLink.rel = 'stylesheet';
      cssLink.href = window.themeAssetUrls?.splideCss || '';
      if (cssLink.href) document.head.appendChild(cssLink);
    }

    if (typeof Splide !== 'undefined') {
      this._mountAll(scope);
      return;
    }

    if (this._splideAssetsRequested) return;
    this._splideAssetsRequested = true;

    const script = document.createElement('script');
    script.src = window.themeAssetUrls?.splideJs || '';
    script.defer = true;
    script.onload = () => this._mountAll(document);
    document.body.appendChild(script);
  }

  _mountAll(scope) {
    if (typeof Splide === 'undefined') return;

    const root = scope?.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-product-carousel]').forEach(el => this._mountOne(el));
  }

  _mountOne(el) {
    if (el.dataset.carouselReady === 'true') return;
    el.dataset.carouselReady = 'true';

    const slides = el.querySelectorAll(':scope > .splide__track > .splide__list > .splide__slide');
    const gap = el.dataset.carouselGap ? `${el.dataset.carouselGap}px` : undefined;
    const peek = el.dataset.carouselPeek ? `${el.dataset.carouselPeek}px` : undefined;

    const instance = new Splide(el, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: slides.length > 1,
      drag: slides.length > 1,
      gap,
      padding: peek ? { right: peek } : undefined,
    });
    instance.mount();

    window.initProductCardSliders?.(el);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.ProductCarouselManager = new ProductCarouselManager();
});
